import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "./baseApi";

// Importar los archivos de endpoints para que se registren en baseApi via injectEndpoints.
// El orden no importa — todos inyectan en la misma instancia.
import "./services";
import "./stats";
import "./subscribers";
import "./organizations";
import "./incidents";
import "./me";
import "./traces";
import "./categories";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

// Habilita `refetchOnFocus` / `refetchOnReconnect` globalmente.
setupListeners(store.dispatch);

// Tipos para hooks tipados (useAppDispatch / useAppSelector si los necesitamos).
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
